import { useGetUser3DsTxs as useGetUser3DsTxsQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetUser3DsTxsProps = {
  cardId: number;
  pageNum?: number;
  pageSize?: number;
  orderNo?: string;
  cardNo?: string;
  startTime?: number;
  endTime?: number;
  type?: 'THIRD_3DS_OTP' | 'AUTH_URL';
};

/* Hook */
export const useGetUser3DsTxs = ({
  cardId,
  pageNum = 1,
  pageSize = 10,
  orderNo,
  cardNo,
  startTime,
  endTime,
  type,
}: UseGetUser3DsTxsProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { data, isLoading, isError, error } = useGetUser3DsTxsQuery({
    enabled: !!id && !!cardId,
    userId: id ?? 0,
    cardId: cardId ?? 0,
    requestData: {
      pageNum,
      pageSize,
      orderNo,
      cardNo,
      startTime,
      endTime,
      type,
    },
  });

  /* Return */
  return {
    isLoading,
    isError,
    error,
    total: data?.total,
    records: data?.records,
  };
};
